import { randomString } from './randomString';

export default randomString;
